import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { ListItemIcon, ListItemText } from '@mui/material';
import { ContentCut } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';

export type optionType = { key: string, title: string, enabled: boolean, [key: string]: any }[]

type SplitButtonProps = {
  options: optionType,
  selectedIndex: number,
  onIndexChange: (index: number) => void,
  onClick: (value: string) => void,
  disabled?: boolean
}
export default function SplitButton({ options, selectedIndex, onIndexChange, onClick, disabled = false }: SplitButtonProps) {




  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement | null>(null);


  //Filter for disabled Options


  const handleClick = () => {
    onClick(options[selectedIndex].key)
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    onIndexChange(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label="Button group with a nested menu"
      >
        <LoadingButton
          loading={disabled}
          onClick={handleClick}>{options[selectedIndex].title}</LoadingButton>
        <Button
          disabled={disabled}
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 10 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper
              sx={{
                background: "hsla(0, 0%, 5%, .4)", // darker or more opaque
                backdropFilter: "blur(10px)", // stronger blur
                WebkitBackdropFilter: "blur(10px)", // Safari
                maxHeight: '300px', overflowY: 'auto'
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option.key}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                      disabled={!option.enabled}
                    >

                      <ListItemText>{option.title}</ListItemText>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}
